import { type Context } from '@atlassian/post-office-context';

type Fetcher = (url: string) => Promise<Response> | undefined;

export const defaultFetcher = (url: string, headers?: HeadersInit, fetchOptions?: RequestInit): Promise<Response> =>
	fetch(url, {
		...fetchOptions,
		headers: {
			credentials: 'include',
			mode: 'cors',
			'Content-Type': 'application/json',
			...headers,
			...fetchOptions?.headers,
		},
	});

export const requestInitialData = async (
	placementId: string,
	context: Context,
	fetcher: Fetcher | undefined = defaultFetcher,
	options: {
		baseUrl?: string;
		path: string;
		resource?: string;
	},
): Promise<Response | undefined> => {
	const baseUrl = options.baseUrl;
	const path = options.path;

	const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
	const requestResource = options.resource ? options.resource : '';

	function stringifyObjectValues(input: Context) {
		const entries = Object.entries(input);
		const stringifiedEntries = entries
			.filter(([, v]) => typeof v !== 'undefined' && v !== null)
			.map(([key, value]) => [key, String(value)]);
		return Object.fromEntries(stringifiedEntries) as Record<string, string>;
	}

	const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
	contextAsSearchParams.sort();

	const url = encodeURI(
		`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`,
	);

	// Response will be handled inside the component
	return fetcher(url);
};
